import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import PropTypes from 'prop-types';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup } from 'reactstrap';
import { Link } from 'react-router-dom'
import Lightbox from 'react-image-lightbox';

export default class Featured extends Component {
  static propTypes = {
  	addItemToCart: PropTypes.func.isRequired,
  	products: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      lgSelected: true,
      mdSelected: false,
      smSelected: false,
      tartSelected: false,
      votiveSelected: false,
      featuredArray: [],
      selectedProduct: {},
      lgProduct: {},
      lgProductLightboxIndex: 0,
      mdProduct: {},
      mdProductLightboxIndex: 1,
      smProduct: {},
      smProductLightboxIndex: 2,
      votiveProduct: {},
      votiveProductLightboxIndex: 3,
      tartProduct: {},
      tartProductLightboxIndex: 4,
      onDisplayView: true,
      lightboxOpen: false,
      lightboxIndexToOpen: 0
    };
  }

  componentDidMount() {
  	this.createFeaturedArray();
  }

  createFeaturedArray = () => { 
  	let featuredArray = [];

  	this.props.products.map((product, index) => { 
  		if(product.isFeatured) { featuredArray.push(product); } })

  	this.setState({ 
  		featuredArray
  	}, () => this.setInitialProps() )
  }

  setInitialProps = () => {
  	let selectedProduct = this.state.featuredArray[0];
  	let lgProduct; let lgProductLightboxIndex;
  	let mdProduct; let mdProductLightboxIndex;
  	let smProduct; let smProductLightboxIndex;
  	let votiveProduct; let votiveProductLightboxIndex;
  	let tartProduct; let tartProductLightboxIndex;
  	let lightboxIndexToOpen;

  	for(let i=0; i<this.state.featuredArray.length; i++) {
  		let product = this.state.featuredArray[i];

  		// Set large candle as initial display.
  		if(product.sizeOz == "26") {  selectedProduct = product;  lgProduct = product; lgProductLightboxIndex = i; lightboxIndexToOpen = i; }
  		if(product.sizeOz == "16") {  mdProduct = product; mdProductLightboxIndex = i; }
  		if(product.sizeOz == "10") {  smProduct = product; smProductLightboxIndex = i; }
  		if(product.subType == "votive") {  votiveProduct = product; votiveProductLightboxIndex = i; }
  		if(product.subType == "tart") {  tartProduct = product; tartProductLightboxIndex = i; }
  	}
	
  	this.setState({ selectedProduct, lightboxIndexToOpen, lgProduct, mdProduct, smProduct, votiveProduct, tartProduct, 
  		lgProductLightboxIndex, mdProductLightboxIndex, smProductLightboxIndex, votiveProductLightboxIndex, tartProductLightboxIndex })
  }

  toggleButton = (event) => {
  	let selectedProduct = this.state.selectedProduct;
  	let lightboxIndexToOpen = this.state.lightboxIndexToOpen;
  	let lgSelected; let mdSelected; let smSelected; let votiveSelected; let tartSelected;

  	if(event.target.id === "lg") { selectedProduct = this.state.lgProduct; lightboxIndexToOpen = this.state.lgProductLightboxIndex; lgSelected = true;}
  	if(event.target.id === "md") { selectedProduct = this.state.mdProduct; lightboxIndexToOpen = this.state.mdProductLightboxIndex; mdSelected = true;}
  	if(event.target.id === "sm") { selectedProduct = this.state.smProduct; lightboxIndexToOpen = this.state.smProductLightboxIndex; smSelected = true;}
  	if(event.target.id === "votive") { selectedProduct = this.state.votiveProduct; lightboxIndexToOpen = this.state.votiveProductLightboxIndex; votiveSelected = true;}
  	if(event.target.id === "tart") { selectedProduct = this.state.tartProduct; lightboxIndexToOpen = this.state.tartProductLightboxIndex; tartSelected = true;}

  	this.setState({ selectedProduct, lightboxIndexToOpen, lgSelected, mdSelected, smSelected, votiveSelected, tartSelected });
  }

  addToCartClick = () => {
	this.props.addItemToCart(
		this.state.selectedProduct.id, this.state.selectedProduct.name,
		this.state.selectedProduct.price, this.state.selectedProduct.url, 
		this.state.selectedProduct.sizeOz, this.state.selectedProduct.sizeDisplay, this.state.selectedProduct.featuredURL, true
	);
  }

  render() {
  	return (
		<Container_s fluid>
			

	        {this.state.lightboxOpen && this.state.selectedProduct !== undefined ? 
	          <Lightbox mainSrc={this.state.selectedProduct.featuredURL} 
	            onCloseRequest={() => this.setState({lightboxOpen: false})} />
	        : ""
	        }
			
			{this.state.selectedProduct !== undefined
			?
			<Container_1000>
				<h3>Candle of the Month</h3>
				<Row>
					<Col xs="12" lg="7" xl="8">
						<img src={this.state.selectedProduct.featuredURL} onClick={() => this.setState({lightboxOpen: true})}></img>	
					</Col>
					
					<Col xs="12" lg="5" xl="4">
						<CotmMessageP>
							{this.state.selectedProduct.featuredDescription} {' '}
							Please enjoy <span>20% off</span> on this special throughout the month. Thanks from Primitives Candles!
						</CotmMessageP>
						<TypeSelectorButtonGroup>
							<TypeSelectorButton id="lg" buttonSelected={this.state.lgSelected} onClick={this.toggleButton}>
								26oz
							</TypeSelectorButton>
							<TypeSelectorButton id="md" buttonSelected={this.state.mdSelected} onClick={this.toggleButton}>
								16oz
							</TypeSelectorButton>
							<TypeSelectorButton id="sm" buttonSelected={this.state.smSelected} onClick={this.toggleButton}>
								10oz
							</TypeSelectorButton>
							<TypeSelectorButton id="votive" buttonSelected={this.state.votiveSelected} onClick={this.toggleButton}>
								Votive
							</TypeSelectorButton>
							<TypeSelectorButton id="tart" buttonSelected={this.state.tartSelected} onClick={this.toggleButton}>
								Tart
							</TypeSelectorButton>
						</TypeSelectorButtonGroup>
					</Col>
				</Row>
				<Row>
					<Col xs="12" lg="7">
						<PriceContainer>
							<LineThroughSpan>
								<span>{this.state.selectedProduct.originalPriceDisplay}</span>
							</LineThroughSpan>
							{' '}
							<DiscountedPriceSpan>{this.state.selectedProduct.priceDisplay}</DiscountedPriceSpan>
						</PriceContainer>
					</Col>
				</Row>
				<Row> {/* This can be centered under this candle spot OR just centered in whole container. Decide when all set up */}
					<Col xs="12" lg="7">
						<BuyNowButton size="md" 
							onClick={this.addToCartClick}>
							{/*<Link to="/store">ADD TO CART</Link>*/}
							<span>ADD TO CART</span>
						</BuyNowButton>
					</Col>
				</Row>
			</Container_1000>
			: ""
			}
		</Container_s>
  	);
  }
}
/*
const DropdownToggle_s = styled(({ dropdownOpen, ...rest }) => <DropdownToggle {...rest} />)`
        border-top-width: ${a => a.dropdownOpen ? "0!important" : "4.3px!important;"};
`
;
*/
const PriceContainer = styled.div`
	background-color: #ac7339;
`;

const LineThroughSpan = styled.span`
	color: red;
	text-decoration: line-through;

	span {
		color: black;
		font-size: 16px;
		font-weight: normal;
		${media.md` font-size: 17px; `}
		${media.lg` font-size: 18px; `}
		${media.xl` font-size: 19px; `}
		${media.xxl` font-size: 20px; `}
	}
`;
const DiscountedPriceSpan = styled.span`
	font-weight: bold;
	font-family: 'Old Standard TT';
	font-size: 18px;
	${media.md` font-size: 19px; `}
	${media.lg` font-size: 20px; `}
	${media.xl` font-size: 21px; `}
	${media.xxl` font-size: 22px; `}
`;

const CotmMessageP = styled.p`
	text-align: left;
	font-family: 'Raleway';
	font-size: 16px;
	padding-bottom: 15px;

	span {
		font-weight: bold;
		color: #004d1a;
	}

	${media.md` font-size: 17px; `}
	${media.lg` font-size: 18px; `}
	${media.xl` font-size: 19px; `}
	${media.xxl` font-size: 20px; `}
`;

const TypeSelectorButtonGroup = styled(ButtonGroup)`
	margin: 0 0 10px 0;
`;
const TypeSelectorButton = styled(({ buttonSelected, ...rest }) => <Button {...rest} />)`
	margin: 0!important;
	cursor: pointer;
	font-size: 12px!important;
	font-family: 'Raleway'!important;
	font-weight: bold!important;
	padding: 8px 12px 8px 12px!important;
	background-color: ${a => a.buttonSelected ? "#8B572A!important" : "white"};
	border: ${a => a.buttonSelected ? "none!important" : "1px solid #ccc!important"};
	border-radius: ${a => a.buttonSelected ? "0!important" : "initial!important"};
	color: ${a => a.buttonSelected ? "white!important" : "black!important"};

	:hover{
		background-color: ${a => a.buttonSelected ? "#8B572A!important" : "#d9d9d9!important"}; 
		color: ${a => a.buttonSelected ? "white!important" : "#8B572A!important"}; 
	}
	:focus {
		box-shadow: none!important;
	}

	${media.sm` font-size: 14px!important; padding: 8px 16px 8px 16px!important`}
	${media.md` font-size: 16px!important;`}
`;

const BuyNowButton = styled(Button)`
	display: block!important;
	margin: 0 auto;
	margin-bottom: 20px;
	border: 0px!important;
	background-color: #8B572A!important;
	cursor: pointer;

	span {
		color: white;
		font-family: 'Raleway';
		font-size: 16px;
		${media.sm` font-size: 18px;`}

		:hover {
			color: white;
			text-decoration-line: none;
		}
	}

    :hover {
      background-color: #dfbf9f!important;
    }
    :focus {
      box-shadow: none;
    }
    :active {
      background-color: #dfbf9f!important;
    }
`;

const Container_1000 = styled(Container)`
	padding: 0!important;
	margin: 0 auto!important;
	
	background-color: #ac7339;
	
	h3 {
		margin-bottom: 15px;
		font-weight: bold;
		font-size: 36px;
		color: white;
		${media.md` font-size: 38px; `}
		${media.lg` font-size: 40px; `}
		${media.xl` font-size: 42px; `}
		${media.xxl` font-size: 44px; `}
	}
	.row {
		background-color: #ac7339;

		.col-12 {
			background-color: #ac7339;

			img {
				display: block;
				margin: 0 auto;
				margin-bottom: 15px;
				width: 100%;
				height: auto;
				cursor: pointer;

				${media.lg` width: 95%; `}
				
			}

		}
	}
`;

const Container_s = styled(Container)`
	padding: 20px 15px 0 15px!important;
	text-align: center;
	background-color: #ac7339;
`;


// WEBPACK FOOTER //
// ./src/components/Featured.js